/* Mounts the scroll engine on the homepage and remounts it when the theme
   editor adds, removes or reorders a section, so pinned acts stay measured. */
(function () {
  var instance = null;

  /* ---- the flight --------------------------------------------------------
     The hero card's glasses lift out of the card, stay on screen while the page
     scrolls from the hero into the put-on, and land on the put-on's shelf, where
     the put-on takes over and fits them on the face. One fixed element carries
     the frame between the two sections, so it is never hidden. Everything is a
     function of scroll position, so scrolling back up plays it in reverse.
     Runs only when the hero card and the put-on show the same product, and
     never under reduced motion. */
  var START = 0.65;   // hero progress when the glasses lift out of the card
  var END = 0.1;      // put-on progress when they touch down on the shelf
  var ROLL = -12;     // degrees of roll at mid-flight
  var flight = null;

  function clamp01(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
  function smooth(x) { x = clamp01(x); return x * x * (3 - 2 * x); }
  function ease(x) { return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }

  function flightStop() {
    if (!flight) return;
    window.removeEventListener('scroll', flight.onScroll);
    window.removeEventListener('resize', flight.onScroll);
    if (flight.fly.parentNode) flight.fly.parentNode.removeChild(flight.fly);
    flight.hero.style.removeProperty('--zf-card');
    flight.hero.style.removeProperty('--zf-img');
    flight.put.style.removeProperty('--zf-pack');
    flight.put.classList.remove('is-flying');
    flight.card.style.visibility = '';
    flight = null;
  }

  function flightStart() {
    flightStop();
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var put = document.querySelector('[data-zmt-flight-to]');
    if (!put) return;
    var card = document.querySelector('[data-zmt-flight-from="' + put.getAttribute('data-zmt-flight-to') + '"]');
    if (!card) return;
    var hero = card.closest('[data-sc-act]');
    var src = card.querySelector('img');
    var dst = put.querySelector('.z-put__pack');
    if (!hero || hero === put || !src || !dst) return;

    dst.loading = 'eager';
    var fly = document.createElement('div');
    fly.className = 'zmt-flyer';
    fly.setAttribute('aria-hidden', 'true');
    var img = document.createElement('img');
    img.alt = '';
    img.decoding = 'async';
    img.src = dst.currentSrc || dst.src;
    fly.appendChild(img);
    document.body.appendChild(fly);
    put.classList.add('is-flying');

    var queued = false;
    flight = {
      fly: fly, hero: hero, put: put, card: card, src: src, dst: dst, w: 0, on: false, t: -1,
      onScroll: function () {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(function () { queued = false; flightUpdate(); });
      }
    };
    // Registered after the engine's own scroll listener, so this frame's read
    // runs after the engine has moved the parallax planes and set --sc-p.
    window.addEventListener('scroll', flight.onScroll, { passive: true });
    window.addEventListener('resize', flight.onScroll);
    flightUpdate();
  }

  function flightUpdate() {
    var f = flight;
    if (!f) return;
    var y = window.scrollY, vh = window.innerHeight;
    var h = f.hero.getBoundingClientRect(), p = f.put.getBoundingClientRect();
    var a = h.top + y + Math.max(h.height - vh, 1) * START;
    var b = p.top + y + Math.max(p.height - vh, 1) * END;
    var t = clamp01((y - a) / Math.max(b - a, 1));

    if (t !== f.t) {
      f.t = t;
      f.hero.style.setProperty('--zf-card', (1 - smooth(t / 0.3)).toFixed(3));
      f.hero.style.setProperty('--zf-img', t > 0 ? '0' : '1');
      f.put.style.setProperty('--zf-pack', t >= 1 ? '1' : '0');
      f.card.style.visibility = t >= 0.3 ? 'hidden' : '';
    }
    if (t <= 0 || t >= 1) {
      if (f.on) { f.fly.classList.remove('is-on'); f.on = false; }
      return;
    }

    var r0 = f.src.getBoundingClientRect(), r1 = f.dst.getBoundingClientRect(), e = ease(t);
    if (Math.abs(f.w - r1.width) > 0.5) {
      f.w = r1.width;
      f.fly.style.width = f.w + 'px';
      f.fly.style.height = f.w + 'px';
    }
    var w = r0.width + (r1.width - r0.width) * e;
    var cx = (r0.left + r0.width / 2) * (1 - e) + (r1.left + r1.width / 2) * e;
    var cy = (r0.top + r0.height / 2) * (1 - e) + (r1.top + r1.height / 2) * e;
    f.fly.style.setProperty('--zf-m', smooth(t / 0.15).toFixed(3));
    f.fly.style.setProperty('--zf-e', Math.sin(Math.PI * e).toFixed(3));
    f.fly.style.transform = 'translate3d(' + (cx - f.w / 2).toFixed(2) + 'px,' + (cy - f.w / 2).toFixed(2) + 'px,0) scale(' +
      (w / f.w).toFixed(4) + ') rotate(' + (ROLL * Math.sin(Math.PI * e)).toFixed(2) + 'deg)';
    if (!f.on) { f.fly.classList.add('is-on'); f.on = true; }
  }

  function mount() {
    if (!window.ScrollCraft) return;
    if (instance && instance.destroy) instance.destroy();
    instance = window.ScrollCraft.mount(document.getElementById('MainContent') || document.body);
    flightStart();
  }
  function later() { window.requestAnimationFrame(mount); }
  document.addEventListener('DOMContentLoaded', mount);
  window.addEventListener('load', function () { if (flight) flightUpdate(); });
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (type) {
    document.addEventListener(type, later);
  });
})();
